import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import {
  convertToCurrencyFormat,
  stockUnitOfMeasureOptions,
  isReadOnlyUser,
  getSerialFromBarcode,
} from "../../../../shared/utility";
import SelectMenu from "../../../controls/SelectMenu";

export default function OrderSubtable1(props) {
  const {
    data,
    onItemEditComplete,
  } = props;

  const bodyProductName = (item) => {
    const productName = item.manufactured_product?.product_name || "";
    const plu = item.manufactured_product?.plu || "";
    return (
      <div className="flex gap-2">
        {item.is_legacy === 1 ? <p className="text-lg my-auto">L</p> : null}
        <div>
          {productName} <br />{" "}
          <span className="font-bold">PLU: {plu}</span>
        </div>
      </div>
    );
  };

  const rowStyleClass = (data) => {
    if (data.credit_return_id > 0) {
      return { "bg-cyan-100": true };
    } else if (data.is_returned === 0) {
      return { "bg-gray-100": true };
    } else if (data.is_returned === 1) {
      return { "bg-yellow-100": true };
    }
    return {};
  };

  const barcodeBody = (rowData) => {
    const returned =
      rowData.credit_return_id > 0
        ? "CR"
        : rowData.is_returned === 1
          ? " RETURNED"
          : null;

    return (
      <p>
        {getSerialFromBarcode(rowData.manufactured_product.barcode)} {returned}
      </p>
    );
  };

  const weightInKgBody = (rowData) => {
    return (
      <div>
        <p>{rowData.net_weight_kg}kg</p>
        <p>{rowData.net_weight_lbs}lbs</p>
      </div>
    );
  };

  const pieceCountBody = (rowData) => {
    return <p>{rowData.piece_count} pieces</p>;
  };

  const unitCostBody = (rowData) => {
    return <p>{convertToCurrencyFormat(rowData.unit_cost)}</p>;
  };

  const totalCostBody = (rowData) => {
    return <p>{convertToCurrencyFormat(rowData.total_cost)}</p>;
  };

  const unitTypeBody = (rowData) => {
    const unitType = rowData.stock_unit_of_measurement;
    switch (unitType) {
      case 1:
        return "kg";
      case 2:
        return "lbs";
      case 3:
        return "pieces";
      default:
        return rowData.stock_unit_of_measurement_name || "N/A";
    }
  };

  const textEditor = (options) => {
    return (
      <InputText
        type="text"
        style={{ minWidth: "8rem" }}
        className="h-9"
        value={options.value}
        onChange={(e) => options.editorCallback(e.target.value)}
        onKeyDown={(e) => e.stopPropagation()}
      />
    );
  };

  const itemTypeDropdown = (options) => {
    const unitType = options.rowData.stock_unit_of_measurement;
    return (
      <SelectMenu
        handleInputChange={(e) => {
          options.editorCallback(e.target.value.value);
        }}
        name="stock_unit_of_measurement"
        options={stockUnitOfMeasureOptions}
        value={stockUnitOfMeasureOptions.find(
          (el) => el.value === unitType
        )}
        showLabel={false}
        menuPortalTarget={document.body}
      />
    );
  };

  const onRowEditComplete = (e) => {
    if (!onItemEditComplete) return;

    let { newData, index } = e;

    // Ensure unit_cost is properly formatted as string with 4 decimals
    const unitCost = parseFloat(newData.unit_cost || 0);
    newData["unit_cost"] = unitCost.toFixed(4);

    var newTotalCost = 0;
    const unitType = newData.stock_unit_of_measurement;

    if (unitType === 2) {
      // lbs
      newTotalCost = unitCost * parseFloat(newData.net_weight_lbs || 0);
    } else if (unitType === 3) {
      // pieces
      newTotalCost = unitCost * parseFloat(newData.piece_count || 0);
    } else {
      // kg (default)
      newTotalCost = unitCost * parseFloat(newData.net_weight_kg || 0);
    }

    // Update both total_cost and ensure stock_unit_of_measurement is set
    newData["total_cost"] = newTotalCost.toFixed(4);
    newData["stock_unit_of_measurement"] = unitType;
    newData["subtotal_amount"] = newTotalCost.toFixed(4);
    newData["tax_amount"] = "0.0000";

    onItemEditComplete(newData, index);
  };

  const isReadOnly = isReadOnlyUser();

  return (
    <div>
      <DataTable
        value={data}
        dataKey="id"
        tableClassName="min-w-full bg-white divide-y divide-gray-300 text-sm custom-datatable-items-table shipping-sub-items-table"
        cellClassName="py-2 border-1-bottom-gray px-2 text-sm"
        rowClassName={rowStyleClass}
        editMode="row"
        onRowEditComplete={onRowEditComplete}
      >
        <Column
          header="Product"
          body={bodyProductName}
          style={{ width: "15%" }}
        />
        <Column
          header="Lot Number"
          field="manufactured_product.lot_number"
          style={{ width: "12%" }}
        />
        <Column
          header="Serial"
          body={barcodeBody}
          style={{ width: "12%" }}
        />
        <Column
          header="Weight (kg)"
          body={weightInKgBody}
          style={{ width: "10%", textAlign: "right" }}
        />
        <Column
          header="Piece Count"
          body={pieceCountBody}
          style={{ width: "10%", textAlign: "right" }}
        />
        <Column
          header="Unit Price"
          field="unit_cost"
          style={{ width: "10%", textAlign: "right" }}
          body={unitCostBody}
          editor={(options) => textEditor(options)}
        />
        <Column
          header="Subtotal Price"
          field="subtotal_amount"
          style={{ width: "10%", textAlign: "right" }}
          body={totalCostBody}
        />
        <Column
          header="Unit Type"
          field="stock_unit_of_measurement_name"
          headerStyle={{ minWidth: "8rem" }}
          body={unitTypeBody}
          editor={(options) => itemTypeDropdown(options)}
        />
        {!isReadOnly && (
          <Column
            rowEditor={true}
            headerStyle={{ minWidth: "6rem" }}
            bodyStyle={{ textAlign: "center" }}
          />
        )}
      </DataTable>
    </div>
  );
}
